import { render, staticRenderFns } from "./ContractTerms.vue?vue&type=template&id=ac8a756a&scoped=true"
import script from "./ContractTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractTerms.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContractTerms.vue?vue&type=style&index=0&id=ac8a756a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8a756a",
  null
  
)

export default component.exports